export class TaskAssignObject {

    public static TAKEN: TaskAssignObject = new TaskAssignObject("TAKEN");
    public static LEFT: TaskAssignObject = new TaskAssignObject("LEFT");
    public static UNKNOWN: TaskAssignObject = new TaskAssignObject("UNKNOWN");


    constructor(public state: string) {
    }

    public equals(taskAssign: TaskAssignObject): boolean {
        return this.state === taskAssign.state;
    }
}